import React, { useEffect, useMemo, useState, useRef } from "react";
import "../css/header.css";
import {
    getActivePipeline,
    onPipelineChange,
    offPipelineChange,
    clearActivePipeline,
    setDrawerCollapsed,
    getDrawerCollapsed
} from "../Utility/CreatePipeline/pipelineState";
import { useLocation, useNavigate } from "react-router-dom";

function StepBadge({ index, name, status }) {
    return (
        <div className={`pl-step ${status}`}>
            <div className="pl-step-circle">{index + 1}</div>
            <div className="pl-step-name">{name}</div>
        </div>
    );
}

export default function PipelineDrawer() {
    const [pipeline, setPipeline] = useState(getActivePipeline());
    const [collapsed, setCollapsed] = useState(getDrawerCollapsed());
    const location = useLocation();
    const navigate = useNavigate();

    const rootRef = useRef(null);
    const innerRef = useRef(null);

    // ascolta cambiamenti allo stato pipeline
    useEffect(() => {
        const handler = () => setPipeline(getActivePipeline());
        onPipelineChange(handler);
        return () => offPipelineChange(handler);
    }, []);

    //controllo rotte
    useEffect(() => {
        const p = getActivePipeline();
        if (!p?.active) return;

        const steps = p.board || [];
        const expectedUrl = steps[p.currentIndex]?.url;
        const cameFromPipeline = location.state?.fromPipeline === true;

        // Se la navigazione NON è stata fatta dalla pipeline,
        // e non siamo nemmeno sulla pagina dello step atteso ➜ interrompi pipeline
        if (!cameFromPipeline) {
            const isOnExpected = location.pathname === expectedUrl;
            if (!isOnExpected) {
                clearActivePipeline();
            }
        }
    }, [location]); // reagisce a ogni cambio rotta

    // sincronizza stato collapsed
    useEffect(() => {
        const handler = () => setCollapsed(getDrawerCollapsed());
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

    // misura l'altezza della tendina e la espone via CSS var --plHeight
    useEffect(() => {
        const setH = () => {
            const h = innerRef.current?.offsetHeight ?? 0;
            if (rootRef.current) rootRef.current.style.setProperty("--plHeight", `${h}px`);
        };
        setH();
        window.addEventListener("resize", setH);
        window.addEventListener("orientationchange", setH);
        return () => {
            window.removeEventListener("resize", setH);
            window.removeEventListener("orientationchange", setH);
        };
    }, [pipeline?.board]); // ricalcola se cambiano gli step

    const steps = pipeline?.board || [];
    const currentIndex = pipeline?.currentIndex ?? 0;
    const total = steps.length;
    const visible = Boolean(pipeline?.active && total > 0);

    const stepNodes = useMemo(() => {
        return steps.map((step, i) => {
            const status = i < currentIndex ? "done" : i === currentIndex ? "active" : "pending";
            return <StepBadge key={`${step.id}-${i}`} index={i} name={step.name} status={status} />;
        });
    }, [steps, currentIndex]);

    const handleToggle = () => {
        setCollapsed(prev => {
            const next = !prev;
            setDrawerCollapsed(next);
            return next;
        });
    };

    const handleAbort = () => {
        if (window.confirm("Stop current pipeline?")) {
            clearActivePipeline();
            if (location.pathname !== "/dashboard") navigate("/dashboard");
        }
    };

    if (!visible) return null;

    return (
        <div ref={rootRef} className={`pipeline-drawer ${collapsed ? "collapsed" : "expanded"}`}>
            {/* Tendina */}
            <div ref={innerRef} className="pl-inner">
                <div className="pl-left">
                    <div className="pl-title">Pipeline in esecuzione</div>
                    <div className="pl-steps">{stepNodes}</div>
                </div>
                <div className="pl-right">
                    <div className="pl-actions">
                        {/* NIENTE "Chiudi" QUI */}
                        <button className="button buttonUser" onClick={handleAbort}>Terminate Pipeline</button>
                    </div>
                </div>
            </div>

            {/* Toggle esterno: resta visibile sotto l'header quando chiusa,
          si sposta sotto la tendina quando aperta */}
            <button
                className="pl-toggle"
                onClick={handleToggle}
                aria-label={collapsed ? "Open Pipeline Status" : "Close Pipeline Status"}
            >
                {collapsed ? "Open Pipeline Status ▼" : "Close Pipeline Status ▲"}
            </button>
        </div>
    );
}
